import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPages } from '../../redux/actions/pageActions';
import { Link } from 'react-router-dom';

const PageList: React.FC = () => {
  const dispatch = useDispatch();
  const { pages, paginationInfo, isLoading, error } = useSelector((state: any) => state.pages);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    dispatch(fetchPages());
  }, [dispatch]);

  const loadMore = async () => {
    if (paginationInfo.hasNextPage && !loadingMore) {
      setLoadingMore(true);
      await dispatch(fetchPages(paginationInfo.endCursor));
      setLoadingMore(false);
    }
  };

  if (isLoading && pages.length === 0) {
    return <div className="loading">Loading pages...</div>;
  }

  if (error && pages.length === 0) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="page-list">
      <h1>Pages</h1>
      <div className="pages-grid">
        {pages.map((page: any) => (
          <div key={page.id} className="page-card">
            <h2>{page.title}</h2>
            <p>{page.summary}</p>
            <Link to={`/pages/${page.handle}`}>Read More</Link>
          </div>
        ))}
      </div>
      
      {paginationInfo.hasNextPage && (
        <button 
          onClick={loadMore} 
          disabled={loadingMore}
          className="load-more-button"
        >
          {loadingMore ? 'Loading...' : 'Load More'}
        </button>
      )}
    </div>
  );
};

export default PageList;
